/**
 * Footer for website preview pages.
 * Replace with your Next.js app Footer component when copying templates over.
 */

import React from 'react';

export function Footer() {
  return (
    <footer className="border-t border-[#2C2C2E] bg-[#0B0B0D] py-6 px-4 text-center text-[#8E8E93] text-sm">
      Website preview
    </footer>
  );
}
